import React, { useState, useRef, useEffect } from "react";
import { useAuth } from "../auth/AuthContext";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { updateDoc } from "firebase/firestore";
import {
  getAuth,
  deleteUser,
  EmailAuthProvider,
  reauthenticateWithCredential,
  GoogleAuthProvider,
  reauthenticateWithPopup,
  sendPasswordResetEmail,
} from "firebase/auth";

import HomeButton from "../components/HomeButton";
import "../styles/profile.css";
import { db } from "../firebase";
import {
  collection,
  query,
  where,
  getDocs,
  deleteDoc,
  doc
} from "firebase/firestore";

const EditProfile = () => {
  const { user, login, logout, setUser } = useAuth();
  const { t } = useTranslation();

  const [username, setUsername] = useState(user?.username || "");
  const [phone, setPhone] = useState(user?.phone || "");
const [accountType, setAccountType] = useState(user?.accountType || "");
const [openMore, setOpenMore] = useState(false);
const menuRef = useRef(null);
const navigate = useNavigate();

const [profileSaved, setProfileSaved] = useState(
  !!user?.accountType
);

const auth = getAuth();
const currentUser = auth.currentUser;
const isPasswordUser = currentUser?.providerData?.some(
  (p) => p.providerId === "password"
);

 const handleSave = async () => {
  
 if (!accountType) {
    alert(t("profile.chooseAccountType"));
    return;
  }


try {
    const userRef = doc(db, "users", user.uid);

    // PRIVATE
await updateDoc(doc(db, "users", user.uid), {
  phone
});

// PUBLIC
await updateDoc(doc(db, "publicUsers", user.uid), {
  username,
  accountType,
});

    // 2. update local UI cache AFTER
    const updatedUser = {
  ...user,
  username,
  phone,
  accountType,
};

    setUser(updatedUser);
    localStorage.setItem("user", JSON.stringify(updatedUser));

 setProfileSaved(true);

    // 3. redirect
    navigate("/my-profile");

  } catch (err) {
    console.error(err);
    alert("Failed to save changes");
  }
};

const handleDeleteAccount = async () => {
  const confirmDelete = window.confirm(
    t("profile.delete_confirm_message")
  );

  if (!confirmDelete) return;

  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      alert("No user logged in");
      return;
    }

    const providerId = currentUser.providerData?.[0]?.providerId;

    // 🔹 EMAIL/PASSWORD
    if (providerId === "password") {
      const password = prompt("Please enter your password:");

      if (!password) {
        alert("Password is required");
        return;
      }

      const credential = EmailAuthProvider.credential(
        currentUser.email,
        password
      );

      await reauthenticateWithCredential(currentUser, credential);
    }

    // 🔹 GOOGLE
    else if (providerId === "google.com") {
      const provider = new GoogleAuthProvider();
      await reauthenticateWithPopup(currentUser, provider);
    }

    // 🔹 DELETE USER LISTINGS FIRST
const q = query(
  collection(db, "listings"),
  where("userId", "==", currentUser.uid)
);

const querySnapshot = await getDocs(q);

const deletePromises = querySnapshot.docs.map((docItem) =>
  deleteDoc(doc(db, "listings", docItem.id))
);

await Promise.all(deletePromises);

// 🔹 DELETE PRIVATE USER DOC
await deleteDoc(doc(db, "users", currentUser.uid));

// 🔹 DELETE PUBLIC USER DOC
await deleteDoc(doc(db, "publicUsers", currentUser.uid));

// 🔹 DELETE AUTH USER
await deleteUser(currentUser);

logout();
navigate("/");
  } catch (err) {
    console.error(err);

    if (err.code === "auth/wrong-password") {
      alert("Incorrect password");
    } else if (err.code === "auth/popup-closed-by-user") {
      alert("Google login popup was closed");
    } else if (err.code === "auth/requires-recent-login") {
      alert("Please log in again and retry");
    } else {
      alert("Failed to delete account");
    }
  }
};

const handlePasswordReset = async () => {
  try {
    const auth = getAuth();

    if (!user?.email) {
      alert("No email found");
      return;
    }

    await sendPasswordResetEmail(auth, user.email);

    alert(t("profile.password_reset_sent"));
  } catch (err) {
    console.error(err);
    alert("Failed to send reset email");
  }
};

useEffect(() => {
  const handleClickOutside = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setOpenMore(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () =>
    document.removeEventListener("mousedown", handleClickOutside);
}, []);

useEffect(() => {
  if (user) {
    setUsername(user.username || "");
    setPhone(user.phone || "");
    setAccountType(user.accountType || "");
  }
}, [user]);

if (user === undefined) {
  return <div>Loading...</div>;
}

  return (
    <div className="edit-profile">

<HomeButton disabled={!accountType || !profileSaved} />

      <h2>{t("profile.edit_title")}</h2>


<label className="profile-label required-label">
  {t("profile.accountType")}
  <span className="required-star">*</span>
</label>

<select
  className="profile-input profile-account-type"
  value={accountType}
  onChange={(e) => setAccountType(e.target.value)}
>

 <option value="" disabled>
    {t("profile.chooseAccountType")}
  </option>

  <option value="regular">
    {t("profile.regular")}
  </option>

  <option value="agent">
    {t("profile.agent")}
  </option>

  <option value="agency">
    {t("profile.agency")}
  </option>

  <option value="developer">
    {t("profile.developer")}
  </option>
</select>



      <input
  className="profile-input"
  value={username}
  onChange={(e) => {
    const value = e.target.value;

    if (/^[a-zA-Zა-ჰ\s-]*$/.test(value)) {
      setUsername(value);
    }
  }}
  placeholder={t("profile.username")}
/>

      <input
        className="profile-input"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        placeholder={t("profile.phone")}
      />



      <button className="profile-save-btn" onClick={handleSave}  disabled={!accountType}>
  {t("profile.save")}
</button>

<div className="profile-corner-menu" ref={menuRef}>
 <div className="profile-corner-wrapper"> {/* NEW */}
  <button
    className="profile-more-btn"
    onClick={() => setOpenMore(!openMore)}
  >
    ⋮
  </button>

  {openMore && (
    <div className="profile-menu">

      <div
        className="profile-menu-item"
        onClick={() => {
          logout();
          navigate("/");
        }}
      >
        {t("profile.logout")}
      </div>

{isPasswordUser && (
  <div
    className="profile-menu-item"
    onClick={handlePasswordReset}
  >
    {t("profile.change_password")}
  </div>
)}


      <div
        className="profile-menu-item profile-delete"
        onClick={handleDeleteAccount}
      >
        {t("profile.delete_account")}
      </div>

    </div>
  )}

    </div>
   </div>
  </div>
  );
};

export default EditProfile;
